import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/api";

export const Footer = () => {
  return (
    <footer data-testid="footer">
      {/* Dark call-to-action */}
      <div className="bg-primary text-primary-foreground grain relative">
        <div className="relative z-[2] max-w-[1400px] mx-auto px-6 md:px-10 py-20">
          <div className="grid md:grid-cols-2 gap-12 items-end">
            <div>
              <h2 className="font-serif text-5xl md:text-6xl leading-[0.95] tracking-tight">
                Thinking of
                <br />
                selling your salon?
              </h2>
            </div>
            <div className="md:text-right">
              <p className="text-primary-foreground/70 max-w-md md:ml-auto mb-6 leading-relaxed">
                Salons For Sale, in association with Bonza Business &amp; Franchise
                Sales, are specialists in the sale of hair and beauty salons &mdash;
                with a low 4% commission.
              </p>
              <a
                href="mailto:sales@bonzabfs.com.au"
                data-testid="footer-email"
                className="font-serif text-2xl text-brand hover:opacity-80 transition-opacity"
              >
                sales@bonzabfs.com.au
              </a>
              <div className="mt-6 flex flex-col md:items-end gap-4">
                <a
                  href={CONTACT.phoneTel}
                  data-testid="footer-phone"
                  className="font-serif text-2xl text-primary-foreground hover:text-brand transition-colors"
                >
                  Call {CONTACT.phone}
                </a>
                <a
                  href={CONTACT.calendly}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-book"
                  className="inline-flex items-center gap-2 rounded-full bg-brand text-brand-foreground px-6 py-3 eyebrow hover:bg-white hover:text-primary transition-colors duration-300"
                >
                  Book an Appointment
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Light co-branding lockup */}
      <div className="bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-14 text-center">
            <img
              src="/salons-for-sale.png"
              alt="Salons For Sale"
              className="h-24 w-auto"
              data-testid="footer-logo-sfs"
            />
            <span className="font-serif italic text-xl text-muted-foreground shrink-0">
              in association with
            </span>
            <img
              src="/bonza.png"
              alt="Bonza Business & Franchise Sales"
              className="h-14 w-auto"
              data-testid="footer-logo-bonza"
            />
          </div>

          <div className="mt-10 pt-6 border-t border-border flex flex-col md:flex-row justify-between items-center gap-3 eyebrow text-muted-foreground">
            <span>&copy; {new Date().getFullYear()} Salons For Sale</span>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="hover:text-brand transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
